import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Typography from 'components/molecules/typography'
import CarIdentityPlate from 'components/molecules/car-identity-plate'
import CarfileSellingPrice from 'components/molecules/carfile-selling-price'
import GalleryImage from 'components/atoms/gallery-image'

const Container = styled.header`
  display: flex;
  align-items: stretch;
  flex-direction: row;
  position: sticky;
  top: ${({ theme }) => theme.sizeByFactor(7.5)};
  z-index: 12;
  background: ${({ theme }) => theme.colors.sectionBackground};
`

const LeftColumn = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 auto;
`

const CarTitle = styled.div`
  padding-left: ${({ theme }) => theme.sizings.lvl2};
`

const Brand = styled(Typography)`
  text-transform: uppercase;
  margin: 0;
`

const Model = styled(Typography)`
  text-transform: uppercase;
  margin: 0;
`

const Type = styled(Typography)`
  margin: ${({ theme }) => theme.sizings.lvl0} 0 0 0;
  padding-right: ${({ theme }) => theme.sizings.lvl2};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: ${({ theme }) => theme.sizeByFactor(12.5)};
`

const StyledCarInformationContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizings.lvl0};
  height: ${({ theme }) => theme.sizings.lvl2};
  align-items: center;
`

const StickyCarFileMobileHeader = ({
  carId,
  imagePath,
  brand,
  licensePlate,
  model,
  type,
  modelserie,
  vin,
  carfile,
  carDetailsSummary,
  ...restProps
}) => (
  <Container data-test-e2e="sticky-car-file-mobile-header" {...restProps}>
    <LeftColumn>
      <ImageContainer>
        <GalleryImage
          src={imagePath}
          alt={`A photo of ${brand} ${model}`}
          ratio={16 / 9}
          blurredBackground
        />
        <CarIdentityPlate
          carFileId={carId}
          licensePlate={licensePlate}
          vin={vin}
          size="small"
        />
      </ImageContainer>
      <CarTitle data-test-e2e="car-title">
        <StyledCarInformationContainer>
          {brand && (
            <Brand type="Level3Heading" data-test-e2e="brand">
              {brand}
            </Brand>
          )}
          {model && (
            <Model type="Level3Heading" data-test-e2e="model">
              {`${model}`}
            </Model>
          )}
        </StyledCarInformationContainer>
        {type && (
          <Type type="BodyParagraph" data-test-e2e="type">
            {type.toUpperCase()}
          </Type>
        )}
        {modelserie && (
          <Type type="ExplanationParagraph" data-test-e2e="model-serie">
            {modelserie}
          </Type>
        )}
        {carfile?.data?.sellingprice && (
          <CarfileSellingPrice
            carfile={carfile?.data}
            sellingprice={carfile?.data?.sellingprice}
            taxMargin={carfile?.data?.taxMargin}
            carDetailsSummary
            highlight={false}
            type="input"
          />
        )}
      </CarTitle>
    </LeftColumn>
  </Container>
)

StickyCarFileMobileHeader.propTypes = {
  carId: PropTypes.string,
  brand: PropTypes.string,
  licensePlate: PropTypes.string,
  model: PropTypes.string,
  type: PropTypes.string,
  modelserie: PropTypes.string,
  imagePath: PropTypes.string,
  carfile: PropTypes.object,
  vin: PropTypes.string,
  carDetailsSummary: PropTypes.bool,
}

StickyCarFileMobileHeader.defaultProps = {
  carDetailsSummary: false,
}

export default StickyCarFileMobileHeader
